import React from 'react';

import { randomUuidKey } from 'Helpers/randomUuidKey';
import { Newsletter } from '@autovia-uk/polaris-components/components/organisms/Newsletter';

import 'Styles/components/organisms/_Newsletter.scss';

export const getNewsletter = ({
  props,
  newsletterConfig,
  additionalProps,
}) => {
  if ((typeof props !== 'object' || Object.keys(props).length === 0)
      && (typeof newsletterConfig !== 'object' || Object.keys(newsletterConfig).length === 0)) {
    return false;
  }

  const {
    mainTitle,
    title,
    ctaLabel,
    placeholder,
    subtitle,
    extraClassNames,
    position,
  } = props;

  return (
    <Newsletter
      key={randomUuidKey()}
      mainTitle={mainTitle || newsletterConfig.mainTitle}
      title={title || newsletterConfig.title}
      cta_label={ctaLabel || newsletterConfig.ctaLabel}
      placeholder={placeholder || newsletterConfig.placeholder}
      subtitle={subtitle || newsletterConfig.subtitle}
      extraClassNames={extraClassNames || {}}
      position={position}
      modalOpen={false}
      toggleModal={null}
      {...additionalProps}
    />
  );
};
